export default __webpack_public_path__ + "images/HI.27b6cba.png";